var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPinterest(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_205_367)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.9999 0.0234375C5.37253 0.0234375 0 5.39611 0 12.0233C0 17.1072 3.16289 21.4532 7.62689 23.2017C7.52189 22.2522 7.42716 20.7921 7.66856 19.7555C7.88653 18.819 9.07566 13.7908 9.07566 13.7908C9.07566 13.7908 8.71664 13.072 8.71664 12.0091C8.71664 10.3406 9.68377 9.09488 10.888 9.09488C11.9117 9.09488 12.4064 9.86358 12.4064 10.7852C12.4064 11.8149 11.7509 13.3541 11.4125 14.7806C11.1298 15.9751 12.0115 16.9491 13.1895 16.9491C15.3224 16.9491 16.9618 14.7002 16.9618 11.454C16.9618 8.58089 14.8972 6.57202 11.9494 6.57202C8.53495 6.57202 6.53077 9.13299 6.53077 11.7796C6.53077 12.811 6.92803 13.9169 7.42383 14.5181C7.5218 14.6369 7.53623 14.7411 7.50708 14.8623C7.41591 15.2414 7.21355 16.0564 7.17375 16.2232C7.12139 16.4428 6.9998 16.4895 6.77245 16.3837C5.27367 15.686 4.33669 13.4949 4.33669 11.7349C4.33669 7.94948 7.08694 4.47323 12.2655 4.47323C16.4283 4.47323 19.6634 7.43944 19.6634 11.4037C19.6634 15.5394 17.0557 18.8677 13.4364 18.8677C12.2205 18.8677 11.0773 18.236 10.686 17.4899C10.686 17.4899 10.0843 19.781 9.93839 20.3425C9.66736 21.3848 8.93611 22.6913 8.44692 23.4883C9.56981 23.8359 10.763 24.0234 11.9999 24.0234C18.6275 24.0234 24 18.651 24 12.0233C24 5.39611 18.6275 0.0234375 11.9999 0.0234375Z",
    fill: "#070707"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_205_367"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinterest);
export default __webpack_public_path__ + "static/media/pinterest.3478d946e2e77494d1e50d72241199b7.svg";
export { ForwardRef as ReactComponent };